import { useDeepWorkStore } from '@/shared/stores/deepWorkStore'

export interface UseFocusModeResult {
  /** True whenever a Deep Work session is active. */
  isFocusModeActive: boolean
}

/**
 * Focus Mode (GitHub issue #20).
 *
 * Components read `isFocusModeActive` to dim/fade themselves as
 * non-essential chrome while a Deep Work session is running — see
 * `focusDim` in `@/shared/lib/focusMode` for the shared CVA variant that
 * applies the dim/hover-reveal/reduced-motion behavior.
 *
 * Backed by `useDeepWorkStore`, the single source of truth for Deep Work
 * session state (populated by the `DeepWork` dashboard tile). Do not track
 * "is a session active" anywhere else — read it from here.
 */
export function useFocusMode(): UseFocusModeResult {
  const activeSession = useDeepWorkStore((state) => state.activeSession)
  return { isFocusModeActive: activeSession !== null }
}
